import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { transparentize } from '../../../../helpers';
import { BoolInputProps } from '../../layouts/types';

type SwitchProps = BoolInputProps<'switch'>;

type SwitchStyleProps = Pick<SwitchProps, 'disabled' | 'active' | 'error' | 'value' | 'indeterminate'>;

const style = ({ disabled, active, error, value, indeterminate }: SwitchStyleProps) => {
  return [
    css`
      min-width: 40px;
      width: 40px;
      height: 24px;
      background: ${indeterminate ? theme.colors.primary20 : value ? theme.colors.primary50 : theme.colors.neutral40};
      border: 1px solid ${theme.colors.neutral40};
      border-radius: 12px;
      position: relative;
      outline: transparent 2px solid;
      outline-offset: 2px;
      transition: outline 200ms ease-out;

      .icon {
        transition: opacity 200ms ease-in-out;
        opacity: ${indeterminate ? 1 : 0};
        top: 10%;
        left: calc(50% - 9px);
        position: absolute;
        z-index: ${theme.zIndex.low};
        cursor: pointer;
        height: 18px;
        width: 18px;
      }

      :focus-within {
        outline-color: ${theme.colors.primary50};
      }

      ::after {
        content: '';
        width: 18px;
        height: 18px;
        background: ${theme.colors.white};
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 3px;
        transform: translateY(-50%);
        transition: background 200ms ease-out, left 200ms ease-in-out;
      }
    `,
    !disabled &&
      active &&
      css`
        border-color: ${theme.colors.neutral40};

        ::before {
          transform: scale(1);
        }
      `,
    value &&
      css`
        border-color: ${theme.colors.primary50};

        ::before {
          background: ${transparentize(0.7, theme.colors.primary50)};
        }

        ::after {
          background: ${theme.colors.white};
          left: calc(100% - 21px);
        }
      `,
    indeterminate &&
      css`
        ::after {
          left: calc(50% - 9px);
        }
      `,
    disabled &&
      css`
        opacity: 0.4;
      `,
    !disabled &&
      error &&
      css`
        border-color: ${theme.colors.status.critical};

        ::before {
          background: ${transparentize(0.8, theme.colors.status.critical)};
          border-color: ${theme.colors.status.critical};
        }

        ::after {
          background: ${transparentize(0.6, theme.colors.status.critical)};
        }
      `,
  ];
};

export const SwitchStyles = {
  switch: (switchProps: SwitchStyleProps) => style(switchProps),
};
